export default {
  report: 'Relatório',
  build: 'Build',
  buildAndReport: 'Build e relatório',
  mixed: 'Várias versões do ngtorch',
  kindBranch: 'branch',
  kindCommit: 'commit',
  plans: '{count} plano | {count} planos',
  reinstall: 'Com reinstalação dos metadados do pacote',
  frozenAt: 'Resolvido em {date}',
  withoutOverride: '{count} plano com o ngtorch da imagem | {count} planos com o ngtorch da imagem'
}
